import React from 'react';
import { Link } from 'react-router-dom';
import { Text } from '@is24at/react-ui-core';
import { AwardLabels } from 'components/Awards';
import RealtorLogo from '../RealtorLogo';
import styles from './Realtor.scss';

interface RealtorProps {
  exposePath: string;
  companyName: string;
  addressLines: string[];
  logoUrl: string;
  features: string[];
}

const Realtor = ({
  exposePath,
  companyName,
  addressLines,
  logoUrl,
  features,
}: RealtorProps) => (
  <div className={styles['agency-box']}>
    <Link to={exposePath}>
      <Text tag="h3" bold>
        {companyName}
      </Text>
    </Link>
    <AwardLabels activeFeatures={features} />
    <div className={styles['agency-contact']}>
      <div className={styles['agency-info']}>
        {!!addressLines.length &&
          addressLines.map((address) => <p key={address}>{address}</p>)}
      </div>
      <RealtorLogo logoUrl={logoUrl} />
    </div>
  </div>
);

export default Realtor;
